const devices = state => state.devices
const device = state => state.device.data

export default {
  devices,
  device,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/devices/getters.js